import { IconButton, Tooltip, Typography } from '@mui/material';
import { format } from 'date-fns';
import InfoIcon from '@mui/icons-material/Info';

interface ApplicationStatusProps {
  status?: string;
  editAppStatus?: any;
  permitId?: any;
}

function ApplicationStatus({ status, editAppStatus, permitId }: ApplicationStatusProps) {
  return status ? (
    <span
      style={{
        color:
          status === 'Rejected' || status === 'Fail'
            ? '#8B0000'
            : status === 'Approved' || status === 'Pass' 
              ? 'green'
              : status === 'Issued'
                ? '#b63dff'
                : status === 'In Review' ||
                  status === 'In Review L1' ||
                  status === 'In Review L2' ||
                  status === 'Await CO' || status === 'Requested'
                  ? 'orange'
                  : '#059ee3'
      }}
    >
      {status === 'InReview' ? 'In Review' : status} <br />
      {(status === 'Approved' && (permitId === 9 || permitId === 10)) &&
        <Tooltip title="Final payment is pending!" arrow placement="bottom">
          <Typography color="#FF2C2C">
            Payment Due
          </Typography>
        </Tooltip>
      }
    </span>
  ) : (
    <Typography
      color={
        editAppStatus?.ApplicationStatus === 'Approved' ? 'green' : '#8B0000'
      }
      fontSize={15}
      fontWeight={500}
    >
      {editAppStatus?.ApplicationStatus === 'Approved'
        ? `This application has been successfully approved ${editAppStatus?.ApprovedDate &&
        ` on ${format(new Date(editAppStatus?.ApprovedDate), 'MM/dd/yyyy')}`
        }.`
        : editAppStatus?.ApplicationStatus === 'Rejected'
          ? `This application has been rejected${editAppStatus?.RejectedDate &&
          ` on ${format(new Date(editAppStatus?.RejectedDate), 'MM/dd/yyyy')}`
          }.`
          : ''}
      {editAppStatus?.ApplicationStatus === 'Rejected' && (
        <Tooltip
          title={
            'Reason of rejection -' + ' ' + editAppStatus?.ReasonOfRejection
          }
          arrow
        >
          <IconButton>
            <InfoIcon color="primary" fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Typography>
  );
}

export default ApplicationStatus;
